export default {
  kek: 'kek',
  or: 'or',
  cringe: 'cringe',
  tagline: 'The internet will decide.',
  twitchUrl: 'Twitch channel link',
  start: 'Start',
  error: 'Error',
  warning: 'Warning',
  chatConnected: 'Connected to chat',
  chatError: 'Chat error',
  rewardNotSelected:
    'No reward selected — reward redemptions will be ignored. Open settings to pick one.',
  rewardNotFound:
    'The selected reward no longer exists on the channel. Open settings to pick another.',
  nameErr:
    "That doesn't look right. Enter the channel name or a full link to it.",
  settings: {
    title: 'Settings',
    tagline: 'Tune the stream experience in a fun and simple way.',
    video: 'Video',
    addMethod: 'How to add',
    bitsCount: 'Bit count',
    reward: 'Reward',
    selectReward: 'Select reward',
    duration: 'Duration',
    mins: 'minutes',
    viewCount: 'Min view count',
    queueSize: 'Queue size',
    banwordsFilter: 'Banwords filter',
    enabled: 'Enabled',
    platforms: 'Accepted platforms',
    acceptYoutube: 'Accept YouTube submissions',
    acceptTiktok: 'Accept TikTok submissions',
    acceptTwitch: 'Accept Twitch clip submissions',
    atLeastOnePlatform: 'At least one platform must be enabled',
    selectMethod: 'Select method',
    addMethodSimple: 'Simple message',
    addMethodReward: 'Reward',
    addMethodBits: 'Cheers',
    skipCount: 'Skip vote count',
    variants: 'Variants',
    name: 'Name',
    triggers: 'Triggers',
    skipModifier: 'Skip count modifier',
    color: 'Color',
    selectTrigger: 'Select or type',
    addCustomVariant: 'Add custom variant',
    autoSwitch: 'Autoswitch',
    run: 'Run',
    other: 'Other',
    clearStatistic: 'Clear statistics',
    resetSettings: 'Reset settings',
    exportSettings: 'Export settings',
    importSettings: 'Import settings',
    delete: 'Delete',
    resetSettingsConfirm: 'Are you sure you want to reset all the settings?',
    resetSettingsDone: 'Your settings have been successfully reset',
    clearStatisticConfirm: 'Are you sure you want to clear the statistics?',
    clearStatisticDone: 'Statistics cleared',
    importSettingsDone: 'Settings successfully imported',
    importSettingsError: 'Settings import error',
    yes: 'Yes',
    no: 'No',
  },
  neutral: "It's... OK?",
  kekPrefix: 'EXCELLENT',
  cringePrefix: 'TERRIBLE',
  omegaPrefix: 'OMEGA',
  videoWait: 'Waiting for the video',
  alreadyExistsVideo: 'Video is already in the queue',
  notEmbeddableVideo: 'The author has restricted the display of this video',
  badWordsVideo: 'Video is blocked by a filter',
  tooLongVideo: 'The video is too long',
  tooShortVideo: 'The video is too short',
  notEnoughViewsVideo: "The video doesn't have enough views",
  invalidUrlVideo: 'Invalid video URL',
  apiErrorVideo: 'Failed to fetch video info',
  liveStreamVideo: 'Live streams are not allowed',
  embedFailedVideo: "Video can't be played",
  queueIsFull: 'The queue is full',
  videoQueue: 'Video queue',
  queueSubtitle: 'Now playing and up next.',
  current: 'Current',
  clearAllQueue: 'Clear all',
  queue: 'Queue',
  end: 'End',
  sfxOn: 'SFX ON',
  sfxOff: 'SFX OFF',
  skip: 'Next',
  autoskip: 'Autoskip',
  winnerIs: "Today's winner is",
  noOne: 'nobody',
  createdBy: 'Created by VirtualZer0',
  repeat: 'Again',
  home: 'Home',
  mostKek: 'Most KEK',
  mostCringe: 'Most CRINGE',
  today: 'Today',
  allTime: 'All time',
  statistics: 'Statistics',
  statisticsTagline: 'Time to look at the damage.',
  noData: 'No data',
  kekWinnerTitle: 'Today was a day full of',
  cringeWinnerTitle: 'You piled up a ton of',
  nothingWinnerTitle: 'Kek or Cringe? Or maybe better yet...',
  kekWinnerName: 'KEKS',
  cringeWinnerName: 'CRINGE',
  nothingWinnerName: 'DRAW',
  errEmojiLoading: 'Failed to load emoji from',
};
